module.exports = __webpack_public_path__ + "img/yunlin_map_base.0860a766.png";